//================================================================
//  Page: Agreement
//================================================================

//  Purpose: This page shows the current Agreement

//  Example:
//    <Agreement></Agreement>    

//================================================================


// Libraries
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Contexts
import { GetRoles, GetUser } from '../../../../Library/GlobalContexts';

// Components
import PageComponent from '../../../../Components/PageComponent/PageComponent';
import TabView from '../../../../Components/TabView/TabView';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadCrumbs';
import StatusLabel from '../../../../Components/StatusLabel/StatusLabel';

// Tabs
import Overview from './Tabs/Overview';
import Cyber from './Tabs/Cyber';
import Terms from './Tabs/Terms';
import Contracts from './Tabs/Contracts';
import Allocations from './Tabs/Allocations';

// Functions
import DocumentListener from '../../../../Library/DocumentListener';
import CheckInventoryRole from '../../../../Library/CheckInventoryRole';

// Images

// CSS
import './Agreement.css';

 
export default function Agreement() {

  //------------------------------------------------------
  //  React Router & useContexts
  //------------------------------------------------------
  
    const routerUseLocation = useLocation();
    const params = useParams();
    const navigate = useNavigate();

    const getUser = useContext(GetUser);
    const getRoles = useContext(GetRoles);

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------
  
  // Used to save page status > 'pending', 'onload', 'error-invalid', 'error-fatal', 'access-denied'
    const [pageStatus, setPageStatus] = useState('pending');

    // Used to store the agreement document
    const [agreementDoc, setAgreementDoc] = useState();

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

    // Query Listener
    // - Get Firestore document
    useEffect(() => {

      const agreementid = params.id;

      if (agreementid === '') return;
      if (agreementid === null) return;
      if (getRoles === undefined) return;
      if (getUser === undefined) return;

      // ============================================
      //  Perform role check
      // ============================================

      const roleStatus = CheckInventoryRole('agreements', getRoles, getUser);
      if (roleStatus === 'access-denied') return navigate('/inventory?view=agreements');

      // ============================================
      //  Fetch Data
      // ============================================

      function onLoadChange(document){  

        if (document === undefined) return setPageStatus('forbidden');

        setAgreementDoc(document);
        setPageStatus('onload');

      }
      
      function onError(error){

        console.log(error);
        setPageStatus('error-fatal');
      
      }
      
      const unsubscribe = DocumentListener('agreements', agreementid, onLoadChange, onLoadChange, onError);
      
      return () =>{
        unsubscribe();
      };
        
    // eslint-disable-next-line
    }, [getUser, getRoles]);

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

    return (
      <PageComponent
        pageStatus={pageStatus}
        header={
          <div className='Page-Header-Container' hidden={pageStatus !== 'onload'}>

            <BreadCrumbs
              rootLinkName='Agreements'                      
              rootLinkRoute={`/${routerUseLocation.pathname.split('/')[1]}?view=agreements`}
              childLinkName={agreementDoc?.poanumber}
            ></BreadCrumbs>   

            <div className='flex flex-row gap-4'>
              <p className='font-medium text-[20px] mb-0'>{agreementDoc?.vendor.vendorname}</p>
              <StatusLabel status={agreementDoc?.status}></StatusLabel>
            </div>

          </div>
        }
        body={
          <div>

            <TabView
              defaultView={1}

              //------------------------------------------------------
              // Overview
              //------------------------------------------------------

              oneTitle={'Overview'}
              oneRoute ={`/inventory/agreement/${params.id}?view=overview`}
              oneContent={
                <Overview></Overview>
              }

              //------------------------------------------------------
              // Cyber
              //------------------------------------------------------

              twoTitle={'Cyber'}
              twoRoute ={`/inventory/agreement/${params.id}?view=cyber`}
              twoContent={
                <Cyber></Cyber>
              }

              //------------------------------------------------------
              // Terms
              //------------------------------------------------------

              threeTitle={'Terms'}
              threeRoute ={`/inventory/agreement/${params.id}?view=terms`}
              threeContent={
                <Terms></Terms>
              }

              //------------------------------------------------------
              // Contracts
              //------------------------------------------------------

              fourTitle={'Contracts'}
              fourRoute ={`/inventory/agreement/${params.id}?view=contracts`}
              fourContent={
                <Contracts></Contracts>
              }

              //------------------------------------------------------
              // Allocations
              //------------------------------------------------------

              fiveTitle={'Allocations'}
              fiveRoute ={`/inventory/agreement/${params.id}?view=allocations`}
              fiveContent={
                <Allocations></Allocations>
              }

            ></TabView>    

          </div>
        }
      ></PageComponent> 
    )
}
